import React, { useEffect, useState } from "react";
import { Row, Col, notification } from "antd";
import { componentStyles } from "./BotEnvironmentStyles";
import Chatbox from "../../components/chatbot.conversation/Chatbox";
import amy from "../../assets/images/transparent gif.gif";
import arthur from "../../assets/images/Arthur.gif";
import { getRequest } from "../../api";
import { getUserBots } from "../../api/Avatar";

const BotEnvironment = ({ isDrawerOpen }) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [gifUrl, setGifUrl] = useState(null);
  const [selectedVoice1, setSelectedVoice1] = useState('Amy');
  const userId = Number(localStorage.getItem('userid'));
  const [botsData, setBotsData] = useState({});

  const fetchBotsData = async () => {
    try {
      const response = await getUserBots();
      if (response.success) {
        setBotsData(response.data.reduce((acc, { botName, imageUrl }) => {
          acc[botName] = imageUrl;
          return acc;
        }, {}));
      }
    } catch (error) {
      console.error('Error fetching bot data:', error);
      notification.error({
        message: 'Error fetching bot data',
        description: error.message,
      });
    }
  };

  useEffect(() => {
    const fetchAvatar = async () => {
      try {
        const response = await getRequest('/user/get-avatar');

        if (response.error) {
          console.error("Error fetching avatar:", response.error);
          setSelectedVoice1('Amy');
        } else {
          const avatar = response.avatar;
          if (botsData[avatar]) {
            setGifUrl(botsData[avatar]);  
          } else if (avatar === 'Arthur') {
            setGifUrl(arthur); 
          } else {
            setGifUrl(amy); 
          }

          setSelectedVoice1(avatar);
        }
      } catch (error) {
        console.error("Error fetching avatar:", error);
        setSelectedVoice1('Amy');
      }
    };

    if (userId) {
      fetchAvatar();
    } else {
      console.error("User ID is missing in localStorage.");
      setSelectedVoice1('Amy');
    }
  }, [userId, botsData]);

  useEffect(() => {
    fetchBotsData();
  }, []);

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const sectionsContainerStyle = {
    transition: "opacity 0.3s ease, pointer-events 0.3s ease",
    opacity: isDrawerOpen ? "0.5" : "1",
    pointerEvents: isDrawerOpen ? "none" : "auto",
    width:
      windowWidth <= 600
        ? "100%"
        : windowWidth <= 680
          ? "100%"
          : windowWidth <= 1115
            ? "94%"
            : windowWidth <= 1185
              ? "85%"
              : "75%",
  };

  const [callAnimation, setCallAnimation] = useState(-1);
  const [isTalkingStarted, setIsTalkingStarted] = useState(false);

  return (
    <Row
      justify="center"
      align="middle"
      style={sectionsContainerStyle}
      className="sections-container"
    >
      <Col
        span={20}
        className="section image"
        style={{
          ...(
            selectedVoice1 === "Amy"
              ? componentStyles.sectionDesign
              : componentStyles.sectionDesign2
          ),
          height: '470px',
          overflow: 'hidden',
        }}
      >
        <img key={gifUrl} src={gifUrl} alt="Start Session Page Image" style={{borderRadius: "45%", ...componentStyles.largeImage}} />
      </Col>
      <Col span={24} className="section image">
        <Chatbox
          setAnimationToPlay={setCallAnimation}
          animationToPlay={callAnimation}
          isTalkingStarted={isTalkingStarted}
          setIsTalkingStarted={setIsTalkingStarted}
        />
      </Col>
    </Row>
  );
};

export default BotEnvironment;
